<template>
  <v-container class="height_100p" style="display: contents">
    <v-row class="height_100p" justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="7" align-self="center">
        <v-card
          class="mb-12 mx-auto card-main-text"
          color="secondary"
          elevation="0"
        >
          <div class="round__logo__main">
            <div class="round__logo__sub">
              <img src="../../../public/logo.png" width="50px" height="50px" />
            </div>
          </div>
          <div class="card-main-text-second"></div>

          <v-sheet
            class="v-sheet--offset rounded-lg v-sheet-with-v-shape mx-auto pa-5"
            elevation="12"
            max-width="calc(100% - 65px)"
          >
            <v-card class="mx-auto rounded-lg" elevation="0">
              <v-card-text>
                <div class="m-auto">
                  <h2 class="text-center text-primary-color font-weight-bold">
                    Create Password
                  </h2>
                  <br />
                  <form class="">
                    <v-text-field
                      v-model="password"
                      :append-icon="
                        isPwdVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                      "
                      @click:append="() => (isPwdVisible = !isPwdVisible)"
                      :type="isPwdVisible ? 'text' : 'password'"
                      :label="$t('password')"
                      placeholder="Enter New Password"
                      :error-messages="passwordErrors"
                      clearable
                      @input="$v.password.$touch(), passwordcheck(password)"
                      @blur="$v.password.$touch(), removeblur()"
                      @focus="showpasscheck()"
                      :class="{ 'is-invalid': $v.password.$error }"
                      class="mb-2"
                    >
                    </v-text-field>
                    <v-card class="z-index triangle" v-if="showpass">
                      <v-row no-gutters>
                        <v-col cols="12" md="4" class="d-flex">
                          <div>
                            <v-list nav dense class="d-flex">
                              <div>
                                <v-list-item class="text-left">
                                  <v-list-item-icon class="mr-0">
                                    <v-icon
                                      :color="
                                        has_lowercase && has_uppercase
                                          ? 'green'
                                          : ''
                                      "
                                      >{{
                                        has_lowercase && has_uppercase
                                          ? "mdi-checkbox-multiple-marked-circle"
                                          : "mdi-radiobox-marked"
                                      }}</v-icon
                                    >
                                  </v-list-item-icon>
                                  <v-list-item-content class="ml-2">
                                    <v-list-item-title>
                                      Lowercase &Uppercase</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="text-left">
                                  <v-list-item-icon class="mr-0">
                                    <v-icon
                                      :color="has_number ? 'green' : ''"
                                      >{{
                                        has_number
                                          ? "mdi-checkbox-multiple-marked-circle"
                                          : "mdi-radiobox-marked"
                                      }}</v-icon
                                    >
                                  </v-list-item-icon>
                                  <v-list-item-content class="ml-2">
                                    <v-list-item-title>
                                      Number (0-9)</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>

                                <v-list-item class="text-left">
                                  <v-list-item-icon class="mr-0">
                                    <v-icon
                                      :color="has_special ? 'green' : ''"
                                      >{{
                                        has_special
                                          ? "mdi-checkbox-multiple-marked-circle"
                                          : "mdi-radiobox-marked"
                                      }}</v-icon
                                    >
                                  </v-list-item-icon>
                                  <v-list-item-content class="ml-2">
                                    <v-list-item-title>
                                      Special Character
                                      (!@#$%^&*)</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="text-left">
                                  <v-list-item-icon class="mr-0">
                                    <v-icon
                                      :color="
                                        password.length > 5 ? 'green' : ''
                                      "
                                      >{{
                                        password.length > 5
                                          ? "mdi-checkbox-multiple-marked-circle"
                                          : "mdi-radiobox-marked"
                                      }}</v-icon
                                    >
                                  </v-list-item-icon>
                                  <v-list-item-content class="ml-2">
                                    <v-list-item-title>
                                      Atleast 6 Characters</v-list-item-title
                                    >
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                            </v-list>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-text-field
                      v-model="cpassword"
                      :append-icon="
                        isCPwdVisible
                          ? 'mdi-eye-outline'
                          : 'mdi-eye-off-outline'
                      "
                      @click:append="() => (isCPwdVisible = !isCPwdVisible)"
                      :type="isCPwdVisible ? 'text' : 'password'"
                      :label="$t('cpassword')"
                      placeholder="Re-Enter New Password"
                      :error-messages="cpasswordErrors"
                      clearable
                      @input="$v.cpassword.$touch()"
                      @blur="$v.cpassword.$touch()"
                      :class="{ 'is-invalid': $v.cpassword.$error }"
                      @keydown="enterKeyPressed"
                    ></v-text-field>

                    <v-btn
                      depressed
                      block
                      color="primary"
                      @click="onSubmit()"
                      class="btn-primary mt-3 text-capitalize"
                    >
                      <div>Create password</div>
                    </v-btn>
                  </form>
                </div>
              </v-card-text>
            </v-card>
          </v-sheet>
        </v-card>
        <loading
          :active="loader"
          :is-full-page="fullPage"
          :opacity="0.9"
          color="#ff6b00"
          :height="height"
          :width="width"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, sameAs, minLength } from "vuelidate/lib/validators";
// import { mapGetters } from "vuex";
// import { webbreakdown } from "../../utils/breakpoints";
// import Loading from "vue-loading-overlay";
// import { returnuserTypes } from "../../utils/ConstantDropdowns/userType";
import alerts from "@/mixins/alerts";
import agentService from "@/services/agentService/AgentService.js";
export default {
  mixins: [alerts],
  name: "Registration",
  data() {
    return {
      // webbreakdown,
      // user_types: returnuserTypes(),
      // user_type: "IND",
      isPwdVisible: false,
      isCPwdVisible: false,
      emailId: "",
      password: "",
      cpassword: "",
      termsAndCondition: false,
      istermsdialod: false,
      // alertMsg: {
      //   status: false,
      //   text: "",
      //   timeout: 2000,
      //   color: "blue-grey",
      //   type: "info",
      // },
      loader: false,
      dismissCountDown: 0,
      countDownAlert: 0,
      showError: false,
      showpass: false,

      password_strength: 0,
      has_number: false,
      has_lowercase: false,

      has_uppercase: false,
      has_special: false,
      // progressBarWidth: "",
      // progressBarColor: "#E0E0E0",
      // custom: true,
    };
  },
  created() {
    this.emailId = this.$route.query.email;
    console.log("email", this.$route.query.email);
  },
  validations: {
    // user_type: {
    //   required,
    // },
    password: {
      required,
      minLength: minLength(6),
      validPassowrd: function (value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        const containsSpecial = /[#?!@$%^&*-]/.test(value);
        return (
          containsUppercase &&
          containsLowercase &&
          containsNumber &&
          containsSpecial
        );
      },
    },
    cpassword: {
      required,
      minLength: minLength(6),
      sameAsPassword: sameAs("password"),
      validPassowrd: function (value) {
        const containsUppercase = /[A-Z]/.test(value);
        const containsLowercase = /[a-z]/.test(value);
        const containsNumber = /[0-9]/.test(value);
        const containsSpecial = /[#?!@$%^&*-]/.test(value);
        return (
          containsUppercase &&
          containsLowercase &&
          containsNumber &&
          containsSpecial
        );
      },
    },
  },
  computed: {
    // userTypeErrors() {
    //   const errors = [];
    //   if (!this.$v.user_type.$dirty) return errors;
    //   !this.$v.user_type.required && errors.push("User Type is required");
    //   return errors;
    // },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required");

      return errors;
    },
    cpasswordErrors() {
      const errors = [];
      if (!this.$v.cpassword.$dirty) return errors;
      !this.$v.cpassword.required && errors.push("Password is required");
      !this.$v.cpassword.sameAsPassword &&
        errors.push("Passwords must be same.");
      return errors;
    },
  },
  mounted() {
    console.log(`map getters: ${this.user_email}`);
    console.log(`local storage: ${sessionStorage.getItem("user_email")}`);
  },
  watch: {},
  methods: {
    returnState() {
      return process.env.NODE_ENV === "dev"
        ? "text-white-color primary text-center"
        : "text-primary-color";
    },
    passwordcheck(val) {
      /* eslint-disable */
      console.log("pass :", val);
      const password = val;
      let strength = 0;
      this.has_number = /\d/.test(password);
      if ((this.has_number = /\d/.test(password))) {
        strength += 1;
      }
      this.has_lowercase = /[a-z]/.test(password);
      this.has_uppercase = /[A-Z]/.test(password);
      if (this.has_lowercase && this.has_uppercase) {
        strength += 1;
      }

      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(password);
      if ((this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(password))) {
        strength += 1;
      }
      if (password.length >= 6) {
        strength += 1;
      }

      // If value is less than 2
      if (strength < 2) {
        this.progressBarColor = "red";
        this.progressBarWidth = "10";
      } else if (strength == 3) {
        this.progressBarColor = "orange";
        this.progressBarWidth = "60";
      } else if (strength == 4) {
        this.progressBarColor = "green";
        this.progressBarWidth = "100";
      }
      this.password_strength = strength;
    },
    removeblur() {
      this.showpass = false;
      console.log("input out focus");
    },
    showpasscheck() {
      this.showpass = true;
      console.log("input focus");
    },
    loadpdf() {
      this.istermsdialod = true;
    },
    // enterKeyPressed(event) {
    //   if (event.keyCode == 13) this.onSubmit();
    // },

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.showpass = true;
        return;
      }
      const userDetails = {
        user_name: this.emailId,
        password: this.password,
        user_type: process.env.VUE_APP_USER_TYPE,
      };

      this.loader = true;
      try {
        const responseData = await agentService.Createpassword(userDetails);
        if (responseData && responseData.data.status_code === 200) {
          this.loader = false;
          this.showAlertSuccess(responseData.data.message);
          setTimeout(() => this.$router.push({ name: "Login" }), 1000);
        }
        //  else if (responseData.data.status_code == 401) {
        //   this.loader = false;
        //   this.onSubmit();
        // }
        else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.loader = false;
        console.log(error);
        this.showAlertError("Something went wrong please try again later.");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.custom-select {
  margin-top: 18px;
}
.btn-light {
  font-weight: bold;
  color: $dimgrey;
  background: $white;
  margin: 0 5px;
  &:not(:disabled) {
    &:not(.disabled).active {
      color: $secondary;
    }
    &:not(.disabled) {
      &:active {
        color: $secondary;
      }
    }
  }
  &:hover {
    border: 1px solid red !important;
    color: $dimgrey;
    background: $white;
  }
}
::v-deep ul {
  list-style-type: none !important;
}
.card-title {
  color: $dimgrey;
}
.card-text {
  color: $lightslategrey;
}
label {
  color: $lightslategrey;
}
.logo_img {
  max-height: 70px;
}
.div-signup {
  color: $primary;
  cursor: pointer;
}
::v-deep .btn-light {
  border: 1px solid #d3d3d3 !important;
}
.card {
  border: none;
}
.floating-placeholder {
  color: red;
  font-size: 14px;
  text-align: -webkit-left;
}
.label-policy {
  display: flex;
}
.tcanchor {
  color: #ff6b00;
}
.z-index {
  position: absolute;
  right: 0px;
  top: 190px;
  z-index: 1 !important;
}
// .triangle {
//   contain: initial;
//   overflow: visible;
// }
// .triangle::before {
//   position: absolute;
//   content: "";
//   top: 0;
//   right: 10px;
//   transform: translateY(-100%);
//   width: 10px;
//   height: 13px;
//   border-left: 10px solid transparent;
//   border-right: 10px solid transparent;
//   border-bottom: 13px solid rgb(189, 186, 186);
//   box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
// }

.lead {
  font-weight: 400;
  color: $txt;
}
.v-sheet--offset {
  bottom: -20px;
  top: 70px !important;
  position: relative;
}

.language-selection {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button#input-type__BV_toggle_ {
  font-size: 10px;
}
.forgot-link {
  margin-top: 26px;
  line-height: 3rem;
}

.shadow_class {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  // width: %;
  background: #f8f9fa;
  border-radius: 7px;
}
</style>
